import { useModuleRights } from '../../use-module-rights';
import { useUser } from '../../useUser';

import {
  CanAddPermissionFunction,
  CanConvertPermissionFunction,
  CanDeletePermissionFunction,
  CanEditPermissionFunction,
  UsePermissionsReturn,
} from './types';
import { usePermissionsFunction } from './use-permission-function';

export const usePermissions = (): UsePermissionsReturn => {
  const user = useUser();
  const { rights } = useModuleRights();

  const canAdd = usePermissionsFunction<CanAddPermissionFunction>({
    user,
    rights,
    permission: 'canAdd',
  });

  const canEdit = usePermissionsFunction<CanEditPermissionFunction>({
    user,
    rights,
    permission: 'canEdit',
  });

  const canDelete = usePermissionsFunction<CanDeletePermissionFunction>({
    user,
    rights,
    permission: 'canDelete',
  });

  const canConvert = usePermissionsFunction<CanConvertPermissionFunction>({
    user,
    rights,
    permission: 'canConvert',
  });

  return { canAdd, canEdit, canDelete, canConvert };
};
